export const UserStatus =
{
    Online: 1,
    Busy: 2,
    Away: 3,
    Offline: 0
}